export default __webpack_public_path__ + "static/media/Group 350.f0c2c7bb.png";